import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const TITLE_CLASS = "text-[#232323] text-sm font-medium font-['Matter'] leading-[21px]"
const BODY_CLASS = "text-[#6a6e6e] leading-[90%] text-sm font-normal font-['Matter']"

const PASSAGES = [
  {
    title: 'XIRR',
    body: "XIRR is the annual return on your investment. It considers when you put in or took out money from the fund, to give you an accurate rate of return. XIRR will be unavailable and shown as 'NA' for investments less than a year old."
  },
  {
    title: 'Average NAV',
    body: "NAV is the price of the smallest unit in a mutual fund. Average NAV is the average price of all units you've bought at different prices."
  },
  {
    title: 'Total Units',
    body: 'Total units are the number of units you hold in a fund. One unit in a fund is similar to one share in a company.'
  },
  {
    title: 'Folio Number',
    body: 'Folio Number is a unique identifier used by the fund house to track all your investments within a fund.'
  }
] as const

export const MyInvestmentBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Investment Details'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      heading={heading}
      logoSrc={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/investment-details-bottom-sheet.svg`}
      onDismiss={onDismiss}
    >
      <div className='flex flex-col gap-4'>
        {PASSAGES.map((passage) => (
          <HelpDialogPassage
            key={passage.title}
            accessibleLabel={`${passage.title}. ${passage.body}`}
          >
            <span className={TITLE_CLASS}>{passage.title}</span>
            <br />
            <span className={BODY_CLASS}>{passage.body}</span>
          </HelpDialogPassage>
        ))}
      </div>
    </BottomSheetContent>
  )
}
